import { useContext, useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import LeftSidePopupLayout from "../../../../component/popup/modal-layout";
import XCloseIcon from "../../../../component/icons/x-close";
import Style from "./style.module.css";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import Swal from "sweetalert2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import { Bell, Handshake, XIcon } from "lucide-react";
// import AddLeadModal from "../../../leads/lead/add-update/add-update-lead";
import { GlobalContext } from "../../../../context/Context";
import { Alert, Snackbar } from "@mui/material";
// import AddActivityModal from "../../../activities/activity/add-update/add-update-activity";
import AddLeadModal from "../../../../component/modals/add-update/add-update-lead";
import EditDealModal from "../../../../component/modals/add-edit-modal/EditDealModal";
import AddActivityModal from "../../../mainActivities/activities/activity/add-update/add-update-activity";
// import AddLeadModal from "../../../mainleads/add-update/add-update-lead";

const validationSchema = yup.object().shape({
  name: yup.string().required("Name is required"),
  email: yup.string().email("Invalid email").required("Email is required"),
  password: yup.string().required("Password is required"),
  password_confirmation: yup
    .string()
    .oneOf([yup.ref("password")], "Passwords must match")
    .required("Confirm your password"),
  department: yup.string().required("Select a department"),
  designation: yup.string().required("Designation is required"),
  employee_type: yup.string().required("Select employee type"),
  job_type: yup.string().required("Select job type"),
  reporting_authority: yup.string().required("Select reporting authority"),
  salary: yup.number().required("Salary is required"),
  role: yup.string().required("Role is required"),
  shift: yup.string().required("Select shift"),
  joining_date: yup.string().required("Joining date is required"),
});

const EmployeeDirectoryAddUpdate = ({
  open = null,
  onClose = () => {},
  data = {},
  onChange = () => {},
  tabIndex = 0,
  onError = () => {},
  onSubmit = () => {},
  id = {},
  entitytype = "",
  entityname = {},
  contactId = {},
  onDealUpdated = () => {}, // refresh after update,
  type = "",
}) => {
  const apiCall = useApiCall();

  let { state, dispatch } = useContext(GlobalContext);

  const [navIndex, setNavIndex] = useState(tabIndex || 0);
  const [noticeType, setNoticeType] = useState([]);
  const [alertData, setAlertData] = useState({ isShow: false });

  const [PackageList, setPackageList] = useState([]);
  const [DealStages, setDealStages] = useState([]);
  const [usersList, setUsers] = useState([]);
  const [country, setCountry] = useState([]);
  const [brands, setBrands] = useState([]);
  const [entityData, setEntityData] = useState([]);
  const [hasMoreClients, setHasMoreClients] = useState(true);
  const [isLoadingClients, setIsLoadingClients] = useState(false);
  const [Clients, setClients] = useState([]);
  const [page, setPage] = useState(1);

  // useEffect(() => {
  //   setPackageList(state?.ModalData?.data?.PackageList);
  //   setDealStages(state?.ModalData?.data?.DealStages);
  //   setUsers(state?.ModalData?.data?.UsersList);
  //   setCountry(state?.ModalData?.data?.Countries);
  //   setBrands(state?.ModalData?.data?.BrandList);

  //   console.log("Modal Data ", state?.ModalData.data);

  // },[])

  const Countries = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `location/get-countries`,
      });
      setCountry(res?.data);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const fetchUsers = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `users/agents-list`,
      });

      console.log("Users API Response ===>", res);
      const newUsers = res?.agents || res?.customers || res?.data || [];
      setUsers(newUsers);
    } catch (err) {
      console.error("Error fetching users", err);
    } finally {
    }
  };

  const getBrands = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: "brands/brands-list?is_paginate=0",
      });

      setBrands(res?.data || []);
    } catch (error) {
      console.warn("Error fetching brands:", error);
    }
  };

  const DealPackage = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `brands/brand-packages-list?is_paginate=0`,
      });

      setPackageList(res.data);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const DealStage = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `dealstages/deal-stages-list`,
      });

      // filter out "Won" and "Lost"
      const filteredStages = res.data.filter(
        (stage) => stage.name !== "Won" && stage.name !== "Lost"
      );

      setDealStages(filteredStages);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const fetchEntities = async (search = "") => {
    try {
      const res = await apiCall({
        method: "get",
        url: `activities/get-activity-type?search=${encodeURIComponent(
          search
        )}`,
      });

      const list = res?.data || []; // 👈 safe access to data array

      setEntityData(
        list.map((item) => ({
          id: item.id,
          name: item.name,
          type: item.type,
        }))
      );
    } catch (error) {
      console.error("Error fetching entities:", error);
    }
  };

  const loadClients = async (pageNum = 1, search = "") => {
    // agar search active hai to hamesha page 1 hi chalega
    if (search && pageNum > 1) return;

    if (isLoadingClients || (!hasMoreClients && pageNum !== 1)) return;

    if (pageNum === 1) {
      setHasMoreClients(true);
      setPage(1);
    }

    setIsLoadingClients(true);

    try {
      const url = search
        ? `users/customers-list?search=${encodeURIComponent(search)}`
        : `users/customers-list?page=${pageNum}`;

      const res = await apiCall({ method: "get", url });
      const newClients = res?.customers || [];

      if (pageNum === 1) {
        setClients(newClients);
      } else if (newClients.length === 0) {
        setHasMoreClients(false);
      } else {
        setClients((prev) => [...prev, ...newClients]);
      }

      setPage(pageNum);
    } catch (err) {
      console.error("Error fetching users", err);
    } finally {
      setIsLoadingClients(false);
    }
  };

  useEffect(() => {
    Countries();
    fetchUsers();
    getBrands();
    DealPackage();
    DealStage();
    fetchEntities();
    loadClients();
  }, []);

  // const onSuccess = (message) => {
  //   setAlertData({ isShow: true, type: "success", message: message });
  //   onClose();
  //   // getData({});
  //   // setShowLead(false);
  //   // setCurrentData({});
  // };

  // const onError = (message) => {
  //   setAlertData({ isShow: true, type: "error", message: message });
  // };

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  // const [departmentList, setDepartmentList] = useState([]);
  // const [deptUserList, setDeptUserList] = useState([]);
  // const [shiftList, setShiftList] = useState({});

  // const formik = useFormik({
  //     initialValues: {
  //         name: data?.name || "",
  //         email: data?.email || "",
  //         password: data?.employee_id ? "**********" : "",
  //         password_confirmation: data?.employee_id ? "**********" : "",
  //         department: data?.department || "",
  //         designation: data?.designation || "",
  //         employee_type: data?.emp_emptype || "",
  //         job_type: data?.emp_jobtype || "",
  //         reporting_authority: data?.emp_reportingauthority || "",
  //         salary: data?.emp_salary || "",
  //         role: data?.emp_role || "",
  //         shift: data?.emp_shift_id || "",
  //         joining_date: data?.date_of_joining ? new Date(data.date_of_joining) : "",
  //     },
  //     enableReinitialize: true,
  //     validationSchema,
  //     onSubmit: async (values) => {
  //         let extraField = {}
  //         let id = data?.employee_id;

  //         if (id) {
  //             extraField = {
  //                 "employee_id": id,
  //                 "email": values?.email,
  //                 "name": values?.name,
  //                 "department_id": values.department,
  //                 "ra_id": values.reporting_authority,
  //                 "designation": values.designation,
  //                 "jobtype": values.job_type,
  //                 "salary": values.salary,
  //                 "shift": values.shift,
  //                 "dateofjoining": formik.values.joining_date ? format(new Date(formik.values.joining_date), "yyyy-MM-dd") : null,
  //                 "employee_type": values.employee_type,
  //                 "role": values.role,
  //             }
  //         }

  //         if (!id) {
  //             extraField = {
  //                 "password": values?.password,
  //                 "password_confirmation": values.password_confirmation,
  //                 "name": values?.name,
  //                 "email": values?.email,
  //                 "p_reporting_authority": values.reporting_authority,
  //                 p_joining_date: formik.values.joining_date
  //                     ? format(new Date(formik.values.joining_date), "yyyy-MM-dd")
  //                     : null,
  //                 "p_department": values.department,
  //                 "p_designation": values.designation,
  //                 "p_employee_type": values.employee_type,
  //                 "p_job_type": values.job_type,
  //                 "p_user_type": "9",
  //                 "p_salary": values.salary,
  //                 "p_role": values.role,
  //                 "p_shift": values.shift
  //             }
  //         }

  //         // Perform API POST here
  //         let apiData = JSON.stringify({
  //             ...extraField,
  //         });
  //         try {
  //             if (data?.employee_id) {
  //                 let resp = await apiCall({ method: 'post', url: `update-employee-data`, data: apiData });
  //                 Swal.fire(
  //                     'Submitted!',
  //                     resp?.message,
  //                     'success'
  //                 )

  //                 formik.resetForm();
  //                 popupClosed();
  //                 onChange();
  //             } else {
  //                 let resp = await apiCall({ method: 'post', url: `add-employee`, data: apiData });
  //                 Swal.fire(
  //                     'Submitted!',
  //                     resp?.message,
  //                     'success'
  //                 )

  //                 formik.resetForm();
  //                 popupClosed();
  //                 onChange();
  //             }
  //         } catch (error) {
  //             console.warn("Error : ", error)
  //         }
  //     }
  // });

  // const popupClosed = () => {
  //     onClose();
  // }

  // const getDepartmentList = async () => {
  //     try {
  //         let res = await apiCall({ method: 'get', url: 'get-department-list' });
  //         setDepartmentList(res?.departmentList);
  //     } catch (error) {
  //         console.warn("Error : ", error)
  //     }
  // }
  // const getDeptUsersList = async (deptId) => {
  //     try {
  //         let res = await apiCall({ method: 'get', url: `get-dept-users-list/${deptId}` });
  //         setDeptUserList(res?.deptUsersList);
  //     } catch (error) {
  //         console.warn("Error : ", error)
  //     }
  // }
  // const getShiftList = async () => {
  //     try {
  //         let res = await apiCall({ method: 'get', url: 'get-employee-shift-list' });
  //         setShiftList(res?.shiftList);
  //     } catch (error) {
  //         console.warn("Error : ", error)
  //     }
  // }

  // useEffect(() => {
  //     getDepartmentList();
  //     getShiftList();
  //     let id = data?.employee_id;

  //     if (id) {
  //         getDeptUsersList(data?.department);
  //     }
  // }, []);

  return (
    <div className={Style.modal_body}>
      {/* popupStatus */}
      <LeftSidePopupLayout
        popupStatus={true}
        className={Style.departmentChangeModal}
      >
        <div className={Style.modal_header}>
          <div className={Style.modal_nav}>
            <ul>
              {/* {data?.id && navIndex !== 0 ? null : (
                <li
                  className={navIndex === 0 ? Style.active : null}
                  onClick={() => {
                    setNavIndex(0);
                  }}
                >
                  <div className={Style.icon}>
                    <BriefcaseBusiness size={"1.2em"} />
                  </div>
                  <span>Designation</span>
                </li>
              )} */}
              {(data?.leadid || data?.userid || data?.id || data?.dealid) &&
              navIndex !== 0 ? null : (
                <li
                  className={navIndex === 0 ? Style.active : null}
                  onClick={() => {
                    setNavIndex(0);
                  }}
                >
                  <div className={Style.icon}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="12"
                      viewBox="0 0 13 12"
                      fill="none"
                    >
                      <path
                        d="M11.8036 4.92857H8.16071C8.04238 4.92857 7.94643 4.83262 7.94643 4.71429V1.07143C7.94643 0.479736 7.46669 0 6.875 0C6.28331 0 5.80357 0.479736 5.80357 1.07143V4.71429C5.80357 4.83262 5.70762 4.92857 5.58929 4.92857H1.94643C1.35474 4.92857 0.875 5.40831 0.875 6C0.875 6.59169 1.35474 7.07143 1.94643 7.07143H5.58929C5.70762 7.07143 5.80357 7.16738 5.80357 7.28571V10.9286C5.80357 11.5203 6.28331 12 6.875 12C7.46669 12 7.94643 11.5203 7.94643 10.9286V7.28571C7.94643 7.16738 8.04238 7.07143 8.16071 7.07143H11.8036C12.3953 7.07143 12.875 6.59169 12.875 6C12.875 5.40831 12.3953 4.92857 11.8036 4.92857Z"
                        fill="currentColor"
                      />
                    </svg>
                  </div>
                  <span>
                    {data?.leadid || data?.userid ? "Update" : "Add"}{" "}
                    {data?.userid ? "Contact" : "Lead"}{" "}
                  </span>
                </li>
              )}

              {(data?.leadid || data?.userid || data?.id || data?.dealid) &&
              navIndex !== 1 ? null : (
                <li
                  className={navIndex === 1 ? Style.active : null}
                  onClick={() => {
                    setNavIndex(1);
                  }}
                >
                  <div className={Style.icon}>
                    {/* <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="14"
                      viewBox="0 0 15 14"
                      fill="none"
                    >
                      <path
                        d="M7.125 14C10.99 14 14.125 10.865 14.125 7C14.125 3.13499 10.99 0 7.125 0C3.25999 0 0.125 3.13499 0.125 7C0.125 10.865 3.25999 14 7.125 14ZM6.62499 3.00001C6.62499 2.725 6.84999 2.49999 7.125 2.49999C7.40001 2.49999 7.62502 2.725 7.62502 3.00001V6.76001L9.93752 8.61001C10.1525 8.78251 10.1875 9.09749 10.015 9.3125C9.91749 9.435 9.77251 9.49999 9.62499 9.49999C9.51499 9.49999 9.40498 9.46498 9.31251 9.38999L6.81252 7.39001C6.69502 7.295 6.62503 7.15251 6.62503 7L6.62499 3.00001Z"
                        fill="currentColor"
                      />
                    </svg> */}
                    <Handshake  size={18}/>
                  </div>
                  <span>{data?.dealid ? "Update" : "Add"} Deal</span>
                </li>
              )}

              {(data?.leadid || data?.userid || data?.id || data?.dealid) &&
              navIndex !== 2 ? null : (
                <li
                  className={navIndex === 2 ? Style.active : null}
                  onClick={() => {
                    setNavIndex(2);
                  }}
                >
                  <div className={Style.icon}>
                    {/* <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                    >
                      <path
                        d="M13.0939 11.0227C12.9545 11.5123 12.4883 11.8591 11.9459 11.8766H1.80422C1.2618 11.8591 0.79556 11.5123 0.656162 11.0227C0.466918 10.4377 0.718306 9.80664 1.27108 9.47908C2.22224 8.87971 2.24042 8.11354 2.19195 6.81301C2.11764 5.99951 2.19242 5.18013 2.41308 4.39008C3.03103 2.50715 4.51229 1.33102 6.42067 1.16987V0.774059C6.42067 0.539844 6.6241 0.349976 6.87505 0.349976C7.12599 0.349976 7.32942 0.539844 7.32942 0.774059V1.16987C9.2378 1.33102 10.7191 2.50715 11.337 4.39008C11.5577 5.18013 11.6325 5.99951 11.5581 6.81301C11.5097 8.11353 11.5279 8.87971 12.479 9.47908C13.0318 9.80664 13.2832 10.4377 13.0939 11.0227ZM6.87505 13.6492C7.5534 13.6686 8.177 13.3033 8.45324 12.7247H5.29685C5.57309 13.3033 6.19669 13.6686 6.87505 13.6492Z"
                        fill="currentColor"
                      />
                    </svg> */}
                    <Bell size={18}/>
                  </div>
                  <span>Follow ups</span>
                  {/* {(data?.leadid || data?.userid  || data?.id)? "Update" : "Create"}  */}
                </li>
              )}
            </ul>
          </div>

          <div
            className={Style.close_btn}
            style={{
              position: "absolute",
              top: "-16px",
              right: "-16px",
            }}
            onClick={() => {
              onClose();
            }}
          >
            <XIcon size={"1em"} />
          </div>
        </div>

        {navIndex === 0 && (
          <AddLeadModal
            onClose={() => {
              onClose();
            }}
            onChange={() => {
              onChange();
            }}
            PackageList={PackageList}
            CustomerData={data}
            BrandList={brands}
            DealStages={DealStages}
            Countries={country}
            UsersList={usersList}
            Style={Style}
            onError={onError}
            onSubmit={onSubmit}
          />
        )}

        {navIndex === 1 && (
          <EditDealModal
            open={open}
            onClose={() => onClose()}
            dealData={data}
            PackageList={PackageList}
            DealStages={DealStages}
            UserList={usersList}
            contactId={contactId}
            onDealUpdated={onDealUpdated} // refresh after update
            onSubmit={onSubmit}
            onError={onError}
            ClientList={Clients}
            onLoadMoreClients={loadClients}
            hasMoreClients={hasMoreClients}
            page={page}
            isLoadingClients={isLoadingClients}
            Style={Style}
            type={type}
          />

          // <EditDealModal
          //   open={showAddDealModal}
          //   onClose={() => setShowAddDealModal(false)}
          //   ProductList={products}
          //   PackageList={packages}
          //   DealStages={DealStages}
          //   ClientList={Clients}
          //   UserList={usersList}
          //   onLoadMoreClients={loadClients}
          //   hasMoreClients={hasMoreClients}
          //   page={page}
          //   isLoadingClients={isLoadingClients}
          //   contactId={null}
          //   dealData={null}
          //   onDealUpdated={() => getData({})}
          //   onSubmit={(msg) => onSuccess(msg)}
          //   onError={(msg) => onError(msg)}
          // />
        )}

        {navIndex === 2 && (
          <AddActivityModal
            onSubmit={onSubmit}
            onClose={() => {
              onClose();
              setEntityData([]);
            }}
            onError={onError}
            UsersList={usersList}
            CustomerData={data}
            entityData={entityData}
            onSearchEntity={fetchEntities}
            Style={Style}
            id={id}
            entitytype={entitytype}
            entityname={entityname}
          />
        )}
      </LeftSidePopupLayout>

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default EmployeeDirectoryAddUpdate;
